import { render } from "./ResultTeam.vue?vue&type=template&id=5f84a6a0&scoped=true"
import script from "./ResultTeam.vue?vue&type=script&lang=js"
export * from "./ResultTeam.vue?vue&type=script&lang=js"

import "./ResultTeam.vue?vue&type=style&index=0&id=5f84a6a0&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f84a6a0"]])

export default __exports__